import { render, staticRenderFns } from "./PatrimonioDetalheAmortizacao.vue?vue&type=template&id=9416af7e&scoped=true&"
import script from "./PatrimonioDetalheAmortizacao.vue?vue&type=script&lang=js&"
export * from "./PatrimonioDetalheAmortizacao.vue?vue&type=script&lang=js&"
import style0 from "./PatrimonioDetalheAmortizacao.vue?vue&type=style&index=0&id=9416af7e&scoped=true&lang=stylus&"
import style1 from "./PatrimonioDetalheAmortizacao.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9416af7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VRow,VSimpleTable})
